import uploadIcon from "../assets/HIW-1.svg";
import magicIcon from "../assets/HIW-2.svg";
import detailsIcon from "../assets/HIW-3.svg";
import arrowsIcon from "../assets/HIW-4.svg";
import paletteIcon from "../assets/HIW-5.svg";
import buildPaletteIcon from "../assets/HIW-6.svg"

export const sizes = [
  2,
  3,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  16,
  17,
  18,
  19,
  23,
  24,
  26,
  30,
  31,
  36,
  40,
  69,
  160,
  260,
  270,
  350,
  360,
  6.1,
  9.1,
  11.1,
  12.1,
  13.1,
  18.1,
  660.1,
  "h10",
  "h12",
  "h15",
]; //6.1 = 6" LINK | DB: 6_1

export const genericFinish = [
  "Standard",
  "Chrome",
  "Neon",
  "Pastel & Matte",
  "Metallic & Pearl",
  "Vintage & Retro",
  "Crystal",
];

export const genericColors = [
  "Aqua & Mint",
  "Blue",
  "Coral",
  "Goldenrod",
  "Green",
  "Grey",
  "Mauve & Fuchsia",
  "Orange",
  "Periwinkle",
  "Pink",
  "Purple",
  "Red",
  "White",
  "Yellow",
  "Black",
  "Clear",
  "Blue C",
  "Copper C",
  "Gold C",
  "Gold M",
  "Green C",
  "Pink C",
  "Purple C",
  "Red C",
  "Rose Gold C",
  "Rose Gold M",
  "Silver C",
  "Silver M",
  "Taupe C",
  "Brown",
  "Yellow N",
  "Pink N",
  "Orange N",
  "Green N"
].sort();

export const categories = [
  "Standard",
  "Pearl",
  "Chrome",
  "Metallic",
  "Mirror",
  "Crystal",
  "Reflex",
  "Matte",
  "Neon",
  "Brilliant",
  "Shiny",
  "Satin",
  "Silk",
  "Pastel",
  "Luster",
  "Pastel Rainbow",
  "Metallic & Pearl",
  "Smoothies",
  "Superglow",
  "Translucid",
  "Macaron",
  "Platinum",
  "Vintage",
];

export const brands = [
  "Qualatex",
  "Tuftex",
  "Kalisan",
  "Sempertex",
  "Gemar",
  "Prima",
  "Balloonia",
  "Ellies",
  "Decomex",
  "Elitex",
  "Brookloon",
  "Globos Payaso",
  "BuLuLu",
].sort();

export const accessoriesCategories = [
  "Foil Shape",
  "Foil Number & Letter",
  "Confetti",
  "Tassels",
  "Backdrop/Panel Color",
  "Floral & Greenery",
];

export const addDropdownOptions = [
  { key: "balloon", label: "Latex Balloons" },
  // { key: "foilShape", label: "Foil Shape Balloons" },
  // { key: "foilNumberLetter", label: "Foil Number & Letter Balloons" },
  { key: "confetti", label: "Confetti" },
  { key: "tassel", label: "Tassels" },
  // { key: "backdropPanel", label: "Backdrop/Panel Colors" },
  // { key: "floralGreenery", label: "Greenery & Florals" },
  { key: "custom", label: "Add your own" },
];

export const colorCategories = [
  { name: "Reds" },
  { name: "Pinks" },
  { name: "Oranges" },
  { name: "Yellows" },
  { name: "Greens" },
  { name: "Blues" },
  { name: "Purples" },
  { name: "Whites" },
  { name: "Blacks" },
  { name: "Greys" },
  { name: "Nudes, Browns & Neutrals" },
];

export const sponsors = [
  {
    name: "qualatex",
    image: require("../assets/sponsors/qualatex-logo.png"),
  },
  {
    name: "sempertex",
    image: require("../assets/sponsors/sempertex-logo.png"),
  },
  {
    name: "kalisan",
    image: require("../assets/sponsors/kalisan-logo.png"),
  },
  {
    name: "tuftex",
    image: require("../assets/sponsors/tuftex-logo.png"),
  },
  /* {
    name: "anagram",
    image: require("../assets/sponsors/anagram-logo-soon.png"),
  }, */
  {
    name: "gemar",
    image: require("../assets/sponsors/gemar-logo.png"),
  },
  {
    name: "balloonia",
    image: require("../assets/sponsors/balloonia-logo.png"),
  },
  {
    name: "prima",
    image: require("../assets/sponsors/prima-logo.png"),
  },
  {
    name: "ellies",
    image: require("../assets/sponsors/ellies-logo.png"),
  },
  {
    name: "decomex",
    image: require("../assets/sponsors/decomex-logo.png"),
  },
  {
    name: "brookloon",
    image: require("../assets/sponsors/brookloon-logo.png"),
  },
  {
    name: "elitex",
    image: require("../assets/sponsors/elitex-logo.png"),
  },
  /* {
    name: "payaso",
    image: require("../assets/sponsors/payaso-soon.png"),
  }, */
  /* {
    name: "belbal",
    image: require("../assets/sponsors/belbal-soon.png"),
  }, */
  {
    name: "bululu",
    image: require("../assets/sponsors/bululu-logo.png"),
  },
];

export const homeCards = [
  {
    icon: uploadIcon,
    title: "Upload Image",
    text: (
      <>
        Upload invites, logos or photos.
      </>
    ),
  },
  {
    icon: magicIcon,
    title: "Pick a Color",
    text: (
      <>
        Click on desired color to match.
      </>
    ),
  },
  {
    icon: detailsIcon,
    title: "Get Closest Match",
    text: "Get the closest balloon color!",
  },
  {
    icon: arrowsIcon,
    title: "Explore Details",
    text: (
      <>
        Explore brands, balloon color names,
        <br /> and sizes.
      </>
    ),
  },
  {
    icon: paletteIcon,
    title: "Find Alternatives",
    text: (
      <>
        Find alternative options <br /> in your preferred brands.
      </>
    ),
  },
  {
    icon: buildPaletteIcon,
    title: "Build Palette",
    text: (
      <>
        Build your balloon palette, <br /> save and share it!
      </>
    ),
  },
];

export const homeCardsEs = [
  {
    icon: uploadIcon,
    title: "Sube una imagen",
    text: (
      <>
        Sube invitaciones, logos o fotos.
      </>
    ),
  },
  {
    icon: magicIcon,
    title: "Selecciona un color",
    text: "Haz click en el color deseado para hacer match.",
  },
  {
    icon: detailsIcon,
    title: "Encuentra el globo más similar",
    text: (
      <>
        Descubre el globo que más se asemeja a tu color.
      </>
    ),
  },
  {
    icon: arrowsIcon,
    title: "Explora detalles",
    text: (
      <>
        Descubre marcas, nombres de colores<br/> de globos
        y tamaños disponibles.
      </>
    ),
  },
  {
    icon: paletteIcon,
    title: "Descubre alternativas",
    text: (
      <>
        Encuentra opciones alternativas<br/>
        en tus marcas favoritas.
      </>
    ),
  },
  {
    icon: buildPaletteIcon,
    title: "Crea tu paleta",
    text: (
      <>
        Crea tu paleta de globos, <br /> guárdala y compártela.
      </>
    ),
  },
];
